import { Injectable, inject, isDevMode } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import _ from 'lodash';
import { NgbModal } from '@shared/components/lib-ng/lib-ng-bootstrap/modal/modal';
import { ErrorBase } from '@core/models/error.model';
import { Router } from '@angular/router';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { IResponseErrorHandler } from './response-error-handler';

//DOC: https://angular.io/guide/http-intercept-requests-and-responses
@Injectable()
export class ApiVersion2ResponseInterceptor
  implements HttpInterceptor, IResponseErrorHandler
{
  router = inject(Router);
  conf = inject(CoreAuthConfigService);

  NEED_TO_VERIFY_AUTH_INFO_CODE = -3;
  NOT_ALLOW_TO_USE_API = -4;
  NEED_TO_VERIFY_DEVICE = -5;
  ACCESS_TOKEN_EXPIRED = 0;

  constructor(private readonly modalService: NgbModal) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    /**
     * PIPE: [---> handleGlobalError ---> mappingHttpErrorResponseToErrorBase ----> ]
     */
    const API_VERSION_HEADER_KEY = 'X-Api-Version';
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.handleHttpError(error);
        const apiVersion = error.headers.get(API_VERSION_HEADER_KEY);
        return throwError(() => new ErrorBase(error, apiVersion));
      })
    );
  }

  handleHttpError = async (error: HttpErrorResponse) => {
    const errorCode = error.error?.reasons?.options?.code;
    switch (error.status) {
      case HttpStatusCode.Unauthorized:
        switch (errorCode) {
          // Not found token or token expired
          case this.ACCESS_TOKEN_EXPIRED:
            this.modalService.dismissAll();
            this.router.navigate(['login'], { queryParams: { error: 400 } });
            break;

          case -1:
            break;
          // Not found api
          default:
            isDevMode() &&
              console.table([
                {
                  API: error.url,
                  Message: 'API Not declared - please declare them (ADMIN)',
                },
              ]);
            break;
        }
        return EMPTY;

      case HttpStatusCode.Forbidden:
        switch (errorCode) {
          case this.NEED_TO_VERIFY_AUTH_INFO_CODE:
          case this.NEED_TO_VERIFY_DEVICE:
            await this.router.navigate(['cap-nhat-thong-tin']);
            break;

          case this.NOT_ALLOW_TO_USE_API:
            isDevMode() &&
              console.table([
                {
                  API: error.url,
                  Message: 'API Not declared - please declare them (ADMIN)',
                },
              ]);
            break;
          default:
            break;
        }
        return EMPTY;
      default:
        break;
    }

    return error;
  };
}
